import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

export const Step1Identification = ({ formData, handleChange }) => (
  <div className="space-y-6">
    <div>
      <Label className="text-base font-medium mb-3 block">Tipo de Denúncia</Label>
      <RadioGroup
        value={formData.is_anonymous ? 'anonymous' : 'identified'}
        onValueChange={(v) => handleChange('is_anonymous', v === 'anonymous')}
      >
        <div className="flex items-start space-x-3 p-4 border rounded-lg hover:bg-slate-50 cursor-pointer">
          <RadioGroupItem value="anonymous" id="anonymous" />
          <div className="flex-1">
            <Label htmlFor="anonymous" className="font-medium cursor-pointer">Anónima</Label>
            <p className="text-sm text-slate-500 mt-1">
              A sua identidade não será revelada em nenhuma fase do processo.
            </p>
          </div>
        </div>
        <div className="flex items-start space-x-3 p-4 border rounded-lg hover:bg-slate-50 cursor-pointer mt-3">
          <RadioGroupItem value="identified" id="identified" />
          <div className="flex-1">
            <Label htmlFor="identified" className="font-medium cursor-pointer">Identificada</Label>
            <p className="text-sm text-slate-500 mt-1">
              Os seus dados serão protegidos e apenas acessíveis ao gestor de compliance.
            </p>
          </div>
        </div>
      </RadioGroup>
    </div>

    {!formData.is_anonymous && (
      <div className="space-y-4 pt-4 border-t">
        <div>
          <Label htmlFor="reporter_name">Nome Completo *</Label>
          <Input
            id="reporter_name"
            value={formData.reporter_name}
            onChange={(e) => handleChange('reporter_name', e.target.value)}
            placeholder="O seu nome"
            data-testid="reporter-name-input"
          />
        </div>
        <div>
          <Label htmlFor="reporter_email">Email</Label>
          <Input
            id="reporter_email"
            type="email"
            value={formData.reporter_email}
            onChange={(e) => handleChange('reporter_email', e.target.value)}
            placeholder="email@exemplo.com"
          />
        </div>
        <div>
          <Label htmlFor="reporter_phone">Telefone</Label>
          <Input
            id="reporter_phone"
            value={formData.reporter_phone}
            onChange={(e) => handleChange('reporter_phone', e.target.value)}
            placeholder="+351 000 000 000"
          />
        </div>
      </div>
    )}

    <div className="pt-4 border-t">
      <Label htmlFor="notification_email">Email para Notificações (opcional)</Label>
      <Input
        id="notification_email"
        type="email"
        value={formData.notification_email}
        onChange={(e) => handleChange('notification_email', e.target.value)}
        placeholder="email@exemplo.com"
        data-testid="notification-email-input"
      />
      <p className="text-sm text-slate-500 mt-1">
        {formData.is_anonymous
          ? 'Este email não será associado à sua identidade. Será usado apenas para notificações. No entanto deverá usar ou criar um email que não permita a sua identificação (nome, alcunha, etc.).'
          : 'Receberá notificações sobre o estado da sua denúncia.'}
      </p>
    </div>
  </div>
);
